const DEFAULT_ERROR_MESSAGE =
    'Por favor vuelva a intentar, si el problema persiste contacte a soporte.';
const DEFAULT_ERROR_TITLE = 'Ha ocurrido un error.';

export const renderErrorMessage = (statusCode?: number, errorMessage?: string) => {
    switch (statusCode) {
        case 403:
            return {
                title: 'Acceso Denegado',
                message: 'Este usuario tiene el acceso denegado a este módulo',
            };

        case 401:
            return {
                title: 'Acceso Denegado',
                message: 'Nombre de usuario o contraseña inválidos',
            };

        case 405:
            return {
                title: 'Método no permitido',
                message: 'Petición inválida',
            };

        case 404:
            return {
                title: 'Recurso no encontrado',
                message:
                    'La solicitud no pudo ser procesada, el servicio no esta disponible',
            };

        case 500:
            return {
                title: 'Servidor inestable',
                message: 'Ocurrio un error en el servidor al procesar la solicitud',
            };

        default:
            return {
                title: DEFAULT_ERROR_TITLE,
                message: errorMessage ?? DEFAULT_ERROR_MESSAGE,
            };
    }
};
